<template>
  <b-overlay :show="showoverlay" rounded="sm" class="col-md-12">
    <div class="row mb-4">
      <div class="col-12">
        <div class="clearfix row py-2 mb-2 no-margin align-items-center">
          <div class="col-12 col-md-4 pl-0">
            <h5 class="mb-0">Department-wise Attendance Summary</h5>
          </div>
          <div class="col-12 col-md-8 pr-0 d-flex justify-content-md-end justify-content-start align-items-center mt-2 mt-md-0">
            <b-form-group id="summary_date-group" label-for="summary_date" class="mb-0 mr-3" style="width: 200px;">
              <b-input-group class="mb-0">
                <b-form-input @input="getDepartmentAttendanceSummary(0)" id="summary_date" name="summary_date" v-model="summary_filter.date" type="text" placeholder="YYYY-MM-DD" autocomplete="off"></b-form-input>
                <b-input-group-append class="mb-0">
                  <b-form-datepicker @input="getDepartmentAttendanceSummary(0)" id="summary_date_picker" v-b-tooltip.hover.top="'Select the summary date.'" button-only right locale="en-US" v-model="summary_filter.date"></b-form-datepicker>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>

            <b-button variant="secondary" class="custom-secodary-btn mr-2" v-b-toggle.sidebar_right_daily_summary>
              <b-icon icon="funnel-fill" class="mr-1"></b-icon> Filter
            </b-button>
            <b-button variant="primary" @click="getDepartmentAttendanceSummary(1)">
              <b-icon icon="download" class="mr-1"></b-icon> Download Excel
            </b-button>
          </div>
        </div>

        <b-sidebar id="sidebar_right_daily_summary" title="Filter Options" right shadow>
          <template v-slot:default="{ hide }">
            <div class="px-3 py-3">
              <b-form-group label="Branch" label-for="summary_branch_id" class="mb-3">
                <b-form-select id="summary_branch_id" v-model="summary_filter.branch_id" :options="branch_options"></b-form-select>
              </b-form-group>

              <b-form-group label="Department" label-for="summary_department_id" class="mb-3">
                <b-form-select id="summary_department_id" v-model="summary_filter.department_id" :options="department_options"></b-form-select>
              </b-form-group>

              <b-form-group label="Job Position" label-for="summary_jobposition_id" class="mb-3">
                <b-form-select id="summary_jobposition_id" v-model="summary_filter.jobposition_id" :options="jobposition_options"></b-form-select>
              </b-form-group>

              <b-form-group label="Employee Type" label-for="summary_employee_type_id" class="mb-3">
                <b-form-select id="summary_employee_type_id" v-model="summary_filter.employee_type_id" :options="employee_type_options"></b-form-select>
              </b-form-group>

              <div class="mt-4 row">
                <div class="col-6">
                  <b-button variant="primary" block title="Set Filter" @click="getDepartmentAttendanceSummary(0); hide();">Apply Filter</b-button>
                </div>
                <div class="col-6">
                  <b-button variant="secondary" block title="Clear Filter" @click="reset(); hide();">Clear Filter</b-button>
                </div>
              </div>
            </div>
          </template>
        </b-sidebar>
      </div>

      <div class="col-sm-12 px-0 mt-3" v-if="department_summary.length">
        <div class="table-responsive col-12">
          <table class="table table-bordered table-hover dataTable">
            <thead>
              <tr class="table-head">
                <th>S.N</th>
                <th>Department</th>
                <th class="text-center">Present</th>
                <th class="text-center">Late</th>
                <th class="text-center">Early Out</th>
                <th class="text-center">Absent</th>
                <th class="text-center">Leave</th>
                <th class="text-center">Night Shift</th>
                <th class="text-center">Off Day</th>
                <th class="text-center">Unassigned</th>
                <th class="text-center">Total</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(row, index) in department_summary" :key="row.department_id || index">
                <td>{{ index + 1 }}</td>
                <td>{{ row.department || 'N/A' }}</td>
                <td class="text-center">{{ row.present || 0 }}</td>
                <td class="text-center">{{ row.late || 0 }}</td>
                <td class="text-center">{{ row.early || 0 }}</td>
                <td class="text-center">{{ row.absent || 0 }}</td>
                <td class="text-center">{{ row.leave || 0 }}</td>
                <td class="text-center">{{ row.night_shift || 0 }}</td>
                <td class="text-center">{{ row.weekly_off || 0 }}</td>
                <td class="text-center">{{ row.unassigned || 0 }}</td>
                <td class="text-center">{{ row.total || 0 }}</td>
              </tr>
              <tr class="s-tfoot font-weight-bold">
                <td colspan="2">Total</td>
                <td class="text-center">{{ summaryTotal.present }}</td>
                <td class="text-center">{{ summaryTotal.late }}</td>
                <td class="text-center">{{ summaryTotal.early }}</td>
                <td class="text-center">{{ summaryTotal.absent }}</td>
                <td class="text-center">{{ summaryTotal.leave }}</td>
                <td class="text-center">{{ summaryTotal.night_shift }}</td>
                <td class="text-center">{{ summaryTotal.weekly_off }}</td>
                <td class="text-center">{{ summaryTotal.unassigned }}</td>
                <td class="text-center">{{ summaryTotal.total }}</td>
              </tr>

              <tr class="table-head font-weight-bold">
                <td colspan="2" class="text-left rounded-0">Ratio</td>
                <td class="text-center">{{ summaryRatio.present }}%</td>
                <td class="text-center">{{ summaryRatio.late }}%</td>
                <td class="text-center">{{ summaryRatio.early }}%</td>
                <td class="text-center">{{ summaryRatio.absent }}%</td>
                <td class="text-center">{{ summaryRatio.leave }}%</td>
                <td class="text-center">{{ summaryRatio.night_shift }}%</td>
                <td class="text-center">{{ summaryRatio.weekly_off }}%</td>
                <td class="text-center">{{ summaryRatio.unassigned }}%</td>
                <td class="text-center rounded-0">{{ summaryRatio.total }}%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-12 mt-3 px-3" v-else-if="!showoverlay">
        <div class="alert alert-info text-center">No Result Found!</div>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      showoverlay: false,
      department_summary: [],
      employee_department_list: [],
      department_options: [
        { value: null, text: 'All Departments' }
      ],
      branch_options: [
        { value: null, text: 'All Branches' }
      ],
      jobposition_options: [
        { value: null, text: 'All Job Positions' }
      ],
      employee_type_options: [
        { value: null, text: 'All Employee Types' }
      ],
      summary_filter: {
        date: moment().format('YYYY-MM-DD'),
        department_id: null,
        branch_id: null,
        jobposition_id: null,
        employee_type_id: null
      }
    };
  },
  computed: {
    summaryRatio() {
      const base = Number(this.summaryTotal.total || 0);

      if (base === 0) {
        return {
          present: '0.00',
          late: '0.00',
          early: '0.00',
          absent: '0.00',
          leave: '0.00',
          night_shift: '0.00',
          weekly_off: '0.00',
          unassigned: '0.00',
          total: '0.00',
        };
      }

      return {
        present: ((Number(this.summaryTotal.present || 0) / base) * 100).toFixed(2),
        late: ((Number(this.summaryTotal.late || 0) / base) * 100).toFixed(2),
        early: ((Number(this.summaryTotal.early || 0) / base) * 100).toFixed(2),
        leave: ((Number(this.summaryTotal.leave || 0) / base) * 100).toFixed(2),
        absent: ((Number(this.summaryTotal.absent || 0) / base) * 100).toFixed(2),
        night_shift: ((Number(this.summaryTotal.night_shift || 0) / base) * 100).toFixed(2),
        weekly_off: ((Number(this.summaryTotal.weekly_off || 0) / base) * 100).toFixed(2),
        unassigned: ((Number(this.summaryTotal.unassigned || 0) / base) * 100).toFixed(2),
        total: '100.00',
      };
    },
    summaryTotal() {
      return this.department_summary.reduce((total, row) => {
        total.present += Number(row.present || 0);
        total.late += Number(row.late || 0);
        total.early += Number(row.early || 0);
        total.absent += Number(row.absent || 0);
        total.leave += Number(row.leave || 0);
        total.night_shift += Number(row.night_shift || 0);
        total.weekly_off += Number(row.weekly_off || 0);
        total.unassigned += Number(row.unassigned || 0);
        total.total += Number(row.total || 0);

        return total;
      }, {
        present: 0,
        late: 0,
        early: 0,
        absent: 0,
        leave: 0,
        night_shift: 0,
        weekly_off: 0,
        unassigned: 0,
        total: 0,
      });
    }
  },
  mounted() {
    this.loadFilterOptions();
    this.getDepartmentAttendanceSummary();
  },
  methods: {
    moment,
    reset() {
      this.summary_filter.date = moment().format('YYYY-MM-DD');
      this.summary_filter.department_id = null;
      this.summary_filter.branch_id = null;
      this.summary_filter.jobposition_id = null;
      this.summary_filter.employee_type_id = null;
      this.getDepartmentAttendanceSummary();
    },
    loadFilterOptions() {
      axios.get(this.$api_url + '/branch/list').then(response => {
        this.branch_options = [
          { value: null, text: 'All Branches' },
          ...response.data.map(item => ({
            value: item.id,
            text: item.name
          }))
        ];
      });
      axios.get(this.$api_url + '/department/list').then(response => {
        this.department_options = [
          { value: null, text: 'All Departments' },
          ...response.data.map(item => ({
            value: item.id,
            text: item.name
          }))
        ];
      });
      axios.get(this.$api_url + '/jobposition/list').then(response => {
        this.jobposition_options = [
          { value: null, text: 'All Job Positions' },
          ...response.data.map(item => ({
            value: item.value,
            text: item.text
          }))
        ];
      });
      axios.get(this.$api_url + '/employeetype/list').then(response => {
        this.employee_type_options = [
          { value: null, text: 'All Employee Types' },
          ...response.data.map(item => ({
            value: item.value,
            text: item.text
          }))
        ];
      });
    },
    getDepartmentAttendanceSummary(export_flg = 0) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(this.summary_filter.date)) {
        return false;
      }
      if (!this.checkNet()) return false;

      this.showoverlay = true;

      const axiosConfig = {
        params: {
          date: this.summary_filter.date,
          department_id: this.summary_filter.department_id,
          branch_id: this.summary_filter.branch_id,
          jobposition_id: this.summary_filter.jobposition_id,
          employee_type_id: this.summary_filter.employee_type_id,
          export_flg: export_flg,
        }
      };

      if (export_flg == 1) {
        axiosConfig.responseType = 'blob';
      }

      axios.get(this.$api_url + '/leave-attendance/attendance/department-summary', axiosConfig)
        .then(response => {
          if (export_flg == 1) {
            this.global_download_file_content(response);
          } else {
            const data = response.data || {};

            this.department_summary = data.summary || [];
            this.employee_department_list = data.employee_department_list || [];
          }

          this.showoverlay = false;
        })
        .catch(error => {
          this.showoverlay = false;
          this.serverError(error);
        });
    }
  }
};
</script>
